import { useCallback, useEffect, useState } from 'react';
import { useSessionContext } from '../../context/SessionContext';
import { Message } from '../../models/Message';
import { log } from '../../tools/LogHelper';
import { stringify } from 'flatted';

/**
 * Publish and/or subscribe to when a new message is sent to a room
 * @param roomId
 * @param shouldSubscribe
 */
export function usePubSubNewRoomMessage(
  roomId: number,
  component = '',
  shouldSubscribe = false
) {
  const [messages, setMessages] = useState<Message[]>();
  const { publish, subscribe, unsubscribe } = useSessionContext();
  const key = `/rooms/${roomId}/new-message`;
  useEffect(() => {
    const callback = (messages: Message[]) => {
      log('pubSubNewRoomMessage', stringify(messages));
      setMessages(
        messages.map(message => {
          message.created = new Date(message.created);
          message.modified = new Date(message.created);
          return message;
        })
      );
    };
    if (shouldSubscribe) {
      subscribe(key, component, callback);
      return () => unsubscribe(key, component, callback);
    }
  }, [key, component, shouldSubscribe, subscribe, unsubscribe]);
  const notifyNewRoomMessage = useCallback(
    (messages: Message[]) => {
      publish(key, messages);
    },
    [key, publish]
  );
  return {
    messages,
    notifyNewRoomMessage
  };
}
